import { useRouter } from 'next/router';
import { useCallback } from 'react';

// Union type
export type Locale = 'en';

export const useLocale = () => {
  const router = useRouter();

  const switchLocale = useCallback(
    (locale: Locale) => {
      // if we already have /en and we choose english for example we just return!
      if (locale === router.locale) {
        return;
      }

      // This is how we change locale in NextJS.
      const path = router.asPath;
      return router.push(path, path, { locale });
    },
    [router]
  );
  return {
    locale: router.locale,
    switchLocale,
    messages: require(`../localization/${router.locale}.json`),
  };
};
